export default {
  'report.orderNumber': '订单号',
  'report.accountId': '账号ID',
  'report.accountChangeType': '账变类型',
  'report.bonus': '奖金',
  'report.withdrawal': '出款',
  'report.manualWithdrawal': '人工出款',
  'report.manualDeposit': '人工入款',
  'report.withdrawalReversal': '出款退回',
  'report.balanceBeforeChange': '账变前金额',
  'report.changeAmount': '账变金额',
  'report.balanceAfterChange': '账变后金额',
  'report.changeTime': '账变时间',
  'report.moneyDetails': '资金明细',

  'report.date': '日期',
  'report.totalMembers': '会员总计',
  'report.registeredUsers': '注册人数',
  'report.invitedRegisteredUsers': '下级注册人数',
  'report.trafficInviteUsers': '引流用户邀请人数',
  'report.organicInviteUsers': '非引流用户邀请人数',
  'report.restrictedQualifiedInviteUsers': '受限用户合格邀请人数',
  'report.unrestrictedQualifiedInviteUsers': '非受限用户合格邀请人数',
  'report.loggedInUsers': '在线人数',
  'report.oldUserOnlineUsers': '老用户在线人数',
  'report.trafficUserOnlineUsers': '引流用户在线人数',
  'report.restrictedUserOnlineUsers': '受限用户在线人数',
  'report.signedUpUsers': '报名人数',
  'report.contestants': '参赛人数',
  'report.contestantsNonUnique': '参赛人次',
  'report.winners': '得奖人数',
  'report.awardAmount': '得奖金额',
  'report.inviterUsers': '上级人数',
  'report.payoutSubmitUsers': '提交出款人数',
  'report.payoutSuccessUsers': '成功出款人数',
  'report.contestD2Users': '2日参赛人数',
  'report.contestD7Users': '7日参赛人数',
  'report.promotionCost': '推广成本',
  'report.promotionCostPlaceholder': '为空或者整数0～999999999',
  'report.operationsReport': '运营报表',

  'report.dataDefinition': '数据定义',
  // 'report.dataStatisticsDesc1': '数据会在每日北京时间凌晨0时运行统计前一天的数据',
  'report.dataStatisticsDesc1': '数据每一个小时更新一次',
  'report.dataStatisticsDesc2': '所有人数数据默认以唯一性方式进行统计',
  'report.termTrafficUser': '引流用户',
  'report.termTrafficUserDesc': '从锦标赛引流至TOSPORT的用户',
  'report.termRestrictedUser': '受限用户',
  'report.termRestrictedUserDesc': '在TOSPORT提现成功至少2次且充值成功0次的用户',
  'report.termOnlineRule': '在线人数判断规则',
  'report.termOnlineRuleDesc': '在登录的情况下当日有打开网页的用户',
  'report.termQualifiedInvite': '符合邀请条件',
  'report.termQualifiedInviteDesc': '后台配置参加锦标赛数量、完成KYC',
  'report.totalMembersDesc': '截至当日系统所有会员的总数量',
  'report.registeredUsersDesc': '当日成功注册的会员总数量',
  'report.invitedRegisteredUsersDesc':
    '在当日成功注册人数中，通过邀请码成功注册的人数。下级注册人数=引流用户邀请人数+非引流用户邀请人数',
  'report.trafficInviteUsersDesc': '引流用户邀请的下级注册人数',
  'report.organicInviteUsersDesc': '非引流用户邀请的下级注册人数',
  'report.restrictedQualifiedInviteUsersDesc': '受限用户邀请的符合邀请条件的下级注册人数',
  'report.unrestrictedQualifiedInviteUsersDesc': '非受限用户邀请的符合邀请条件的下级注册人数',
  'report.loggedInUsersDesc': '包含原本已经是登录状态的而在当天有访问站点',
  'report.oldUserOnlineUsersDesc': '注册日期早于当日的在线人数',
  'report.trafficUserOnlineUsersDesc': '引流用户的在线人数',
  'report.restrictedUserOnlineUsersDesc': '受限用户的在线人数',
  'report.signedUpUsersDesc': '包含场景如报名后又立刻取消报名',
  'report.contestantsDesc': '包含达开赛状态或出现在积分榜，不包含开赛前取消报名',
  'report.contestantsNonUniqueDesc': '包含达开赛状态或出现在积分榜，用于知道多少人重复参赛的次数',
  'report.winnersDesc': '获奖的人数',
  'report.awardAmountDesc': '获奖的人数的总金额',
  'report.inviterUsersDesc': '下级注册时，使用的邀请码归属多少位唯一上级',
  'report.payoutSubmitUsersDesc': '不包含人工出款',
  'report.payoutSuccessUsersDesc': '包含手动出款，自动出款，人工出款，TOSPORT',
  'report.contestD2UsersDesc': '第2日参赛的人数',
  'report.contestD7UsersDesc': '第7日参赛的人数',
  'report.promotionCostDesc': '不限次数编辑，为空或者整数0～999999999',
  'report.expand': '展开',
  'report.collapse': '收起',

  "report.retained.date": "日期",
  "report.retained.inviteCode": "邀请码",
  "report.retained.currency": "币种",
  "report.retained.registerCount": "注册人数",
  "report.retained.contestD0": "参赛人数",
  "report.retained.withdrawCountD0": "成功提现金额/笔数",
  "report.retained.contestDay": "参赛人数",
  "report.retained.retentionRateDay": "参赛留存率",
  "report.retained.withdrawCountDay": "成功提现金额/笔数",
  "report.retained.startTimePlaceholder": "开始日期",
  "report.retained.endTimePlaceholder": "结束日期",
  "report.retained.export": "导 出",
  "report.retained.exportData": "确认要导出当前筛选条件下的留存报表数据吗？",
  "report.retained.confirm": "确 认",
  "report.retained.cancel": "取 消",
  "report.retained.export1": "留存报表",
  "report.retained.nameListExport": "留存报表名单明细",
  "report.retained.day": "日",
  "report.retained.overallRetentionRate": "整体留存率",
  "report.retained.overallRetentionRateTip": "2日参赛总人数/首次参赛总人数",
  "report.retained.firstContestTotal": "首次参赛总人数",
  "report.retained.firstContestTotalTip": "所有首次参赛人数总和",
  "report.retained.d2ContestTotal": "2日参赛总人数",
  "report.retained.d2ContestTotalTip": "所有2日参赛人数总和",

  // 在线人数
  "report.online.title": "在线人数",
  "report.online.dateA": "日期A",
  "report.online.dateB": "日期B",
  "report.online.peak": "峰值人数",
  "report.online.avg": "平均在线",
  "report.online.trough": "低谷人数",
  "report.online.dailyTotal": "日累计",
  "report.online.trendTitle": "在线人数趋势对比",
  "report.online.detailTitle": "逐时在线人数明细",
  "report.online.time": "时间",
  "report.online.diff": "差值",
};
